import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { InsuranceFlowProposalSnapshotResponse } from 'src/app/_types/insurance-flow.types';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import {
  getProposalStateLabel,
  ProposalState,
} from 'src/app/enums/proposal.enums';

import { TaskLogMetadataDiffComponent } from '../task-log-metadata-diff/task-log-metadata-diff.component';
import { TaskLogProposalFieldsDiffComponent } from '../task-log-proposal-fields-diff/task-log-proposal-fields-diff.component';

@Component({
  selector: 'app-task-log-proposal-diff',
  standalone: true,
  imports: [
    CommonModule,
    TaskLogMetadataDiffComponent,
    TaskLogProposalFieldsDiffComponent,
  ],
  templateUrl: './task-log-proposal-diff.component.html',
  styleUrl: './task-log-proposal-diff.component.css',
})
export class TaskLogProposalDiffComponent {
  @Input() currentSnapshot:
    | InsuranceFlowProposalSnapshotResponse
    | ProposalDetails
    | null = null;

  @Input() baselineSnapshot:
    | InsuranceFlowProposalSnapshotResponse
    | ProposalDetails
    | null = null;

  @Input() compare = true;

  protected getProposalStateLabel(state?: ProposalState): string {
    if (!state) {
      return '-';
    }

    return getProposalStateLabel(state);
  }

  protected isChanged<T>(currentValue?: T, previousValue?: T): boolean {
    return this.compare && currentValue !== previousValue;
  }
}
